import { Tab, withStyles } from '@material-ui/core';

const YellowTab = withStyles({
    root: {
        '&& .MuiTab-wrapper': {
            flexDirection: 'row',
            '& .count': {
                border: '1px solid #FFF',
                borderRadius: '50%',
                marginLeft: 10,
                fontSize: 12,
                height: 22,
                width: 22,
                alignContent: 'center',
            },
        },

    },
    selected: {
        color: '#FFDD00',
        fontWeight: 700,
        '&.enableBackground': {
            backgroundColor: '#B7C9BD',
        },
        '&& .MuiTab-wrapper': {
            flexDirection: 'row',
            '& .count': {
                border: '1px solid #FFDD00',
                backgroundColor: '#FFDD00',
                color: '#098442',
            },
        },
    },
    textColorInherit: {
        opacity: 1,
    },
})(Tab);

export default YellowTab;
